@if (!loader) {
  <div class="mt-2">
    <i-title [text]="'iScan.globalInfos.title' | translate" [buttons]="buttonTitle" class="mb-5 title"></i-title>
    @if (scan) {
      <i-scan
        [(scan)]="scan"
        [splitActions]="buttonsAction"
        [title]="scan.name"
        (onScanSplitActionClick)="onScanSplitActionClick($event)"
        (onScanSplitDetailsClick)="clickDetailsCard($event)"></i-scan>
    }
  </div>
}

<ngx-spinner [name]="'spinnerScan'" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true"
  ><p style="color: white">{{ 'global.saveFileProgress' | translate }}... {{ spinnerCountSave }}/{{ spinnerCountTotal }}</p></ngx-spinner
>

<p-confirmDialog
  key="confirmDialogDetailsScan"
  baseZIndex="560"
  #cd
  [header]="'global.confirmHeader' | translate"
  styleClass="super-compos-modal-content confirmModal"
  icon="bi bi-exclamation-triangle">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>

@if (openModalCreateMailFile) {
  <i-modal
    [visible]="openModalCreateMailFile"
    [header]="modalHeaderCreateMailFile"
    [modalParameters]="modalParamsCreateMailFile"
    (emitterOnVisibleChange)="openModalCreateMailFile = false">
    <div class="d-flex justify-content-center align-items-center">
      <div class="square" (click)="onChooseActionModal('newMailToBeCompleted')" id="newMailToBeCompleted">
        <i class="bi bi-plus-circle-fill fontSizeBiIcon"></i>
        <p class="answerTitle" data-test="newMailToBeCompleted">{{ 'iScan.action.createAMAilToBeCompleted' | translate }}</p>
      </div>
      <div class="square" (click)="onChooseActionModal('newMailComplete')" id="newMailComplete">
        <i class="bi bi-plus-circle-fill fontSizeBiIcon"></i>
        <p class="answerTitle" data-test="newMailComplete">{{ 'iScan.action.createACompleteMail' | translate }}</p>
      </div>
      <div class="square" (click)="onChooseActionModal('duplicateMail')" id="duplicateMail">
        <i class="bi bi-copy fontSizeBiIcon"></i>
        <p class="answerTitle" data-test="duplicateMail">{{ 'iScan.action.duplicateAMail' | translate }}</p>
      </div>
      <div class="square" (click)="onChooseActionModal('attachToAMail')" id="attachToAMail">
        <i class="bi bi-folder-symlink-fill fontSizeBiIcon"></i>
        <p class="answerTitle" data-test="attachToAMail">{{ 'iScan.action.attachToAMail' | translate }}</p>
      </div>
    </div>
  </i-modal>
}

@if (openFastMailCreationModal) {
  <i-modal
    [visible]="openFastMailCreationModal"
    [header]="modalHeaderFastCreation"
    [modalParameters]="modalParamsFastMailCreationModal"
    (emitterOnVisibleChange)="openFastMailCreationModal = false">
    <app-simple-mail-creation-modal
      [scanSplit]="chosenScanSplit"
      [originScan]="scan"
      [scan]="scan"
      (closeModal)="closingModalSimpleMailCreation($event)"></app-simple-mail-creation-modal>
  </i-modal>
}

@if (openDuplicationModal) {
  <i-modal
    [visible]="openDuplicationModal"
    [header]="modalHeaderDuplicate"
    [modalParameters]="modalParamsDuplicate"
    (emitterOnVisibleChange)="attachForm.reset(); openDuplicationModal = false">
    <div class="row" [formGroup]="attachForm">
      <div class="col-md-12 p-fluid">
        <h4 class="custom-h4-title">{{ 'iScan.globalInfos.chooseRecentToDuplicate' | translate }}</h4>
        @if (!listOfRecentMails.length) {
          <i-loader [size]="25"></i-loader>
        }
        @if (listOfRecentMails.length) {
          <p-dropdown
            styleClass="w-100"
            appendTo="body"
            [options]="listOfRecentMails"
            [filter]="true"
            [placeholder]="'homeCourrierChild.selectMail' | translate"
            [showClear]="true"
            formControlName="linkMailId">
            <ng-template let-item pTemplate="item">
              <div class="d-flex align-items-center justify-content-between overflow-ellipsis">
                <div>{{ item?.label | maxLength: 100 }}</div>
                <div class="d-flex align-items-center">
                  <i class="bi bi-info-circle-fill me-2" [pTooltip]="item.label"></i>
                </div>
              </div>
            </ng-template>
          </p-dropdown>
        }
      </div>
      <div class="col-md-6 mt-3">
        <span class="super-compos-label-input">{{ 'iScan.action.duplicateRecipients' | translate }}</span>
        <p-inputSwitch formControlName="duplicateRecipients"></p-inputSwitch>
      </div>
      <div class="col-md-6 mt-3">
        <span class="super-compos-label-input">{{ 'iScan.action.duplicateActions' | translate }}</span>
        <p-inputSwitch formControlName="duplicateActions"></p-inputSwitch>
      </div>
      <div class="col-md-12 mt-2 d-flex justify-content-end">
        <i-button
          [text]="'iScan.action.duplicateTheMail' | translate"
          styleClass="green"
          (click)="submitAttachForm()"
          [disabled]="!attachForm.valid"
          id="buttonAddLinkCourrier">
        </i-button>
      </div>
    </div>
  </i-modal>
}

@if (openAttachmentModal) {
  <i-modal
    [visible]="openAttachmentModal"
    [header]="modalHeaderAttachment"
    [modalParameters]="modalParamsDuplicate"
    (emitterOnVisibleChange)="attachForm.reset(); openAttachmentModal = false">
    <app-attach-scan-to-existing-mail
      [originScan]="originScan"
      [scan]="scan"
      [chosenScanSplit]="chosenScanSplit"
      [expressionReguliereFull]="expressionReguliereFull"
      [listOfCenterNums]="listOfCenterNums"
      (closeModal)="closingAttachmentModal($event)"></app-attach-scan-to-existing-mail>
  </i-modal>
}

@if (openAttachAllModal) {
  <i-modal
    [visible]="openAttachAllModal"
    [header]="modalHeaderAttachAll"
    [modalParameters]="modalParamsAttachAll"
    (emitterOnVisibleChange)="openAttachAllModal = false">
    <app-mass-attach-scans [originScan]="originScan" [scan]="scan" (closeModal)="closingAttachAllModal($event)"></app-mass-attach-scans>
  </i-modal>
}

@if (openProcessAllModal) {
  <i-modal
    [visible]="openProcessAllModal"
    [header]="modalHeaderProcessAll"
    [modalParameters]="modalParamsProcessAll"
    (emitterOnVisibleChange)="openProcessAllModal = false">
    <app-mass-encode-scans
      [splits]="scan.splits"
      [showAllServices]="showAllServices"
      (closeModal)="closingProcessAllModal($event)"></app-mass-encode-scans>
  </i-modal>
}
